import type { FC } from 'react';

import { useFeatureFlagEnabled } from 'posthog-js/react';

import { FeatureFlag } from 'shared/lib/features/common';

import { HubspotChat } from './HubspotChat';
import { InkeepChat } from './InkeepChat';

export const ChatIntegration: FC = () => {
  const isInkeepEnabled = useFeatureFlagEnabled(FeatureFlag.INKEEP_CHAT);

  return isInkeepEnabled ? <InkeepChat /> : <HubspotChat />;
};
